import { css } from '@emotion/react'
import styles from '@mathflat/common/style'
import fontSize from '@mathflat/common/style/fontSize'

const { colors } = styles

const S = {
  default: css`
    display: flex;
    align-items: center;
    gap: 4px;
    height: 100%;
  `,
  size: {
    small: css`
      height: 18px;
      font-size: ${fontSize.caption01};
      svg {
        width: 16px;
        height: 16px;
      }
    `,
    medium: css`
      height: 21px;
      font-size: ${fontSize.body02};
      svg {
        width: 20px;
        height: 20px;
      }
    `,
  },
  colorTheme: {
    lightGray: css`
      color: ${colors.gray.$600};
      path {
        fill: ${colors.gray.$500};
      }
      &:hover {
        color: ${colors.gray.$700};
        text-decoration: underline;
        path {
          fill: ${colors.gray.$600};
        }
      }
    `,
    middleGray: css`
      color: ${colors.gray.$800};
      path {
        fill: ${colors.gray.$700};
      }
      &:hover {
        color: ${colors.gray.$900};
        text-decoration: underline;
        path {
          fill: ${colors.gray.$800};
        }
      }
    `,
    darkGray: css`
      color: ${colors.gray.$900};
      path {
        fill: ${colors.gray.$800};
      }
      &:hover {
        color: ${colors.gray.$900};
        text-decoration: underline;
        path {
          fill: ${colors.gray.$900};
        }
      }
    `,
  },
} as const

export default S
